<template>
  <transition-group
    tag="div"
    :css="false"
    :class="['event-list']"
    @before-enter="beforeEnter"
    @enter="enter"
    @leave="leave"
    appear
  >
    <h4 class="pb-xl" v-if="content" v-html="content" key="content"></h4>
    <h2 key="none" v-if="!filteredEvents.length">No Events found.</h2>
    <template v-else>
      <div
        v-for="(value, key) in eventsByMonth"
        :key="key"
        class="event-list--month"
      >
        <h4
          class="event-list__yeartitle text-blue-p pb-s font-bd"
          v-text="key"
        ></h4>
        <div
          v-for="(events, label) in value"
          :key="key + ' ' + label"
          class="event-list--inner"
        >
          <h4
            class="event-list__monthtitle upper text--m bg-blue-p text-white font-bd p-xs"
            v-text="parseMonthString(label)"
          ></h4>
          <publication-list :children="events" :has-search="false" events>
          </publication-list>
        </div>
      </div>
    </template>
  </transition-group>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  props: {
    children: Array,
    title: String,
    content: String
  },
  mounted() {
    let vm = this,
      events = this.children.filter(event => {
        let p = event.event_properties;
        if (p.event_end_date) {
          return new Date(p.event_end_date) >= new Date();
        }
        return new Date(p.event_start_date) >= new Date();
      });
    events.forEach(event => {
      event.parsedEventDate = vm.parseEventDate(
        event.event_properties,
        event.id
      );
      event.parsedEventLocation = vm.parseEventLocation(event.event_properties);
    });

    this.setEvents(events);
  },
  watch: {
    calendarAttributes() {
      this.setCalendarAttributes(this.calendarAttributes);
    }
  },
  methods: {
    ...mapActions(["setEvents", "setEventsFilter", "setCalendarAttributes"]),
    beforeEnter: function(el) {
      el.style.opacity = 0;
      el.style.transform = "translateY(20%)";
    },
    enter: function(el, done) {
      let lapse = 120,
        delay = el.dataset.index * lapse;
      setTimeout(function() {
        el.animate(
          {
            opacity: [0, 1],
            transform: ["translateY(20%)", "translateY(0)"],
            easing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)"
          },
          { duration: 600, fill: "forwards" }
        ).onfinish = function() {
          done();
        };
      }, delay);
    },
    leave: function(el, done) {
      el.style.opacity = 0;
      el.style.transform = "translateY(120%)";
      done();
    },
    parseMonthString(month) {
      // console.log("parseMonthString > ", month);
      let d = new Date();
      d.setMonth(month - 1); // ZERO BASED
      return d.toLocaleString("default", {
        month: "long"
      });
    },
    stripTimeZone(date) {
      let _date = new Date(date);
      if (_date) {
        let tz = _date.getTimezoneOffset();
        // console.log("date timezone > ", tz);
        if (tz) {
          tz = tz * 60000;
          return new Date(_date.getTime() - tz);
        }
        return _date;
      }
      return date;
    },
    parseMonthDate(date) {
      // let _date = date || props.event_timestamp_start,
      // console.log("parseMonthDate > ", date);
      let _date = this.stripTimeZone(date);
      if (_date) {
        let tz = _date.getTimezoneOffset();
        // console.log("date timezone > ", tz);
        if (tz) {
          tz = tz * 60000;
          _date = new Date(_date.getTime() - tz);
        }
        let day = _date.getDate(),
          month = _date.getMonth() + 1;
        return `${day}.${month}`;
      }
      return "";
    },
    parseDateYear(date) {
      let _date = new Date(date);

      if (_date) {
        return _date.getFullYear();
      }
      return "";
    },
    parseDateMonth(date) {
      let _date = this.stripTimeZone(date);
      if (_date) {
        return _date.getMonth() + 1;
      }
      return "";
    },
    parseEventLocation(props) {
      let cc = props.event_country_code;
      if (cc) {
        return (
          (props.event_place ? props.event_place + ", " : "") +
          props.event_country_code
        );
      }
      return null;
    },
    parseEventDate(props) {
      let start = this.parseMonthDate(props.event_start_date),
        end = this.parseMonthDate(
          props.event_end_date || props.event_start_date
        ),
        start_year = this.parseDateYear(props.event_start_date),
        end_year = this.parseDateYear(
          props.event_end_date || props.event_start_date
        );

      // console.log("PARSEVEVNTDATE > ", start, end, start_year, end_year);
      if (start_year === end_year) {
        return start === end ? start : `${start} - ${end}`;
      }
      return null;
    }
  },
  computed: {
    ...mapState(["dimensions"]),
    ...mapGetters(["filteredEvents"]),
    calendarAttributes() {
      if (this.filteredEvents.length) {
        let attr = this.filteredEvents.map(event => {
          let end = event.event_properties.event_end_date,
            start = event.event_properties.event_start_date;
          let dates = end ? { start, end } : start;
          return {
            key: event.title + event.event_properties.event_start_date,
            dot: true,
            popover: {
              label: event.title,
              positionFixed: true
            },
            dates
          };
        });
        return attr;
      }
      return null;
    },
    eventsByMonth() {
      let events = this.filteredEvents,
        grouped = _.groupBy(events, event =>
          this.parseDateYear(event.event_properties.event_start_date)
        );
      _.forOwn(grouped, (value, key, obj) => {
        obj[key] = _.groupBy(value, ev =>
          this.parseDateMonth(ev.event_properties.event_start_date)
        );
        _.forOwn(obj[key], (v, k) => {
          let sorted = _.sortBy(v, ev => ev.event_properties.event_start_date);
          obj[key][k] = sorted;
        });
      });

      return grouped;
    }
  }
};
</script>

<style lang="stylus">
.event-list--inner
  padding 0 0 40px
+below(815px)//dubix
  .events:not(.page)
    padding-left 0px !important
    padding-right 0px !important
    +landscape()
      padding-top 30px
    .comp-wrap
      position relative
      // top -60px
  .event-list--inner
    position relative
    h4
      padding 10px 15px
      // position absolute
      // top 0
+below(600px)
  .event-list--inner
    h4
      padding 5px 10px
      position relative
</style>

<style lang="stylus" scoped>

.date-bubble
  round(13.5, 'vw')
  background blue_5
  _flex(column, wrap, center, center)
  /.el-size--small &
    round(160, 'px')
  span
    color #fff
    &.big-number
      font-size responsive 54px 80px
      font-range 767px 1900px
      font-weight 400
      line-height 1
      letter-spacing -3.5px
.event-list
  &--month
    padding-top 40px
    margin-top 10px
    +below(815px)
      _flex(row, wrap, flex-start, space-between)
    & > h4
      position absolute
      top 0
    & > *
      display inline-block
      vertical-align top
      width 45%
      margin 0 2%
      +below(815px)
        margin 0
        flex 0 0 calc(50% - 10px)
      // +below(600px)
      //   flex auto
      +below(600px)
        width 100%
        margin 0
        display block
        flex 0 0 100%

  &__yeartitle
      flex 0 0 100%
      width 100%
  // &__monthtitle
  //   border-bottom 3px solid blue_6
    // margin-top 30px
  &--item
    text-align left
    _flex(row, wrap, flex-start, space-between)
    &__right
      flex 0 0 68%
      /.el-size--small &
        flex 0 0 100%
        pad('xl', top)
    // &:first-child
    //   padding-top 0
    &:last-child
      border-bottom 0
    &--title
      color gray_7
      // font-weight bold
      padding-bottom 15px
      margin-bottom 15px
      position relative
      &:after
        content ''
        position absolute
        width 25%
        height 1px
        background gray_3
        left 0
        bottom 0
    &--placetime
      /.el-size--small &
        & > span
          display block
          marg(0)
    p
      padding-bottom 10px
      &:last-child
        padding 0
  >>> .publication-list--item
    max-width initial
</style>
